import {
  MultiDetailTemplateBuilderModel,
  ReportingServicesTemplateBuilderModel,
} from "../../requests/templateBuilder/types";
import {
  CalendarTemplateBuilderModelMulti,
  DbTemplateBuilderModelMulti,
  DetailTemplateBuilderModelMulti,
  HegTemplateBuilderModelMulti,
  HwrTemplateBuilderModel,
  ItemTemplateBuilderModelMulti,
  NotificationTemplateBuilderModelMulti,
  OverviewTemplateBuilderModelMulti,
  PTemplateBuilderModelWithPItems,
  TemplateBuilderModelsThatCanHaveDetail,
  TemplateBuilderModelsWithFunctions,
  TemplateBuilderModelsWithPresentationModel,
  TemplateBuilderModelsWithStandardDataModel,
  TemplatesRepresentedAsATable,
  TemplatesWithTitle,
  TopLevelTemplateBuilderModels,
} from "./templateBuilderModelGroupTypes";
import {
  canHaveDetail,
  hasFunctions,
  hasPresentationModel,
  hasPresentationTemplateItems,
  hasStandardDataModel,
  hasTitle,
  isCalendar,
  isDb,
  isDetail,
  isHeg,
  isHwr,
  isItem,
  isMultiDetail,
  isNotification,
  isOverview,
  isRepresentedAsATable,
  isSsrs,
  isTopLevel,
} from "./templateBuilderModelGuardsCreator";
import { EnforceConstraint } from "../../globalTypes";

export type TemplateBuilderModelGroups = {
  isCalendar: CalendarTemplateBuilderModelMulti;
  isDetail: DetailTemplateBuilderModelMulti;
  isItem: ItemTemplateBuilderModelMulti;
  isMultiDetail: MultiDetailTemplateBuilderModel;
  isNotification: NotificationTemplateBuilderModelMulti;
  isOverview: OverviewTemplateBuilderModelMulti;
  isSsrs: ReportingServicesTemplateBuilderModel;
  isTopLevel: TopLevelTemplateBuilderModels;
  isHwr: HwrTemplateBuilderModel;
  isDb: DbTemplateBuilderModelMulti;
  isHeg: HegTemplateBuilderModelMulti;
  hasFunctions: TemplateBuilderModelsWithFunctions;
  hasPresentationModel: TemplateBuilderModelsWithPresentationModel;
  hasPresentationTemplateItems: PTemplateBuilderModelWithPItems;
  hasStandardDataModel: TemplateBuilderModelsWithStandardDataModel;
  hasTitle: TemplatesWithTitle;
  canHaveDetail: TemplateBuilderModelsThatCanHaveDetail;
  isRepresentedAsATable: TemplatesRepresentedAsATable;
};

export const guards = {
  isOverview,
  isDetail,
  isItem,
  isCalendar,
  isNotification,
  isSsrs,
  isHwr,
  isDb,
  isHeg,
  isMultiDetail,
  isTopLevel,
  canHaveDetail,
  isRepresentedAsATable,
  hasStandardDataModel,
  hasPresentationModel,
  hasFunctions,
  hasTitle,
  hasPresentationTemplateItems,
};

type Check1 = EnforceConstraint<
  keyof typeof guards,
  keyof TemplateBuilderModelGroups
>;

type Check2 = EnforceConstraint<
  keyof TemplateBuilderModelGroups,
  keyof typeof guards
>;
